import styled from 'styled-components';
import { Label } from '@common/components/form/Label';

export const SpaAvailabilityWrapper = styled.div`
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  width: 100%;
  @media screen and (max-width: 850px) {
    border: ${({ theme }) => `1px solid ${theme.defaultColors.lightGrey}`};
    padding: 1rem;
    border-radius: 3px;
  }
`;

export const TitleWrapper = styled.div`
  display: grid;
  height: fit-content;
  width: 100%;
  grid-template-columns: auto auto;
  justify-content: space-between;
  gap: 0.5rem;
  white-space: nowrap;
  align-items: center;
  margin-bottom: 1rem;
`;

export const DividerLine = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  grid-column: 1 / 3;
  margin-bottom: 10px;
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
  }
`;

export const SpaLabel = styled(Label)`
  margin: 0;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 850px) {
    justify-content: flex-start;
    padding: 1rem 0;
  }
`;
